import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, filter, isEmpty, path, propEq, find } from 'ramda';

import magic from '../../../../../../util/magic';
import { toCurrency, getDiscountFromLineItems } from '../../../../../../util/helpers';
import { isNilOrEmpty } from '../../../../../../util/redux';
import { apiAddFile } from '../../../../../../api/registration';

import File from '../../../../../../components/File/index';
import FinalPrice from './FinalPrice';
import FileBrowser from '../../../../../../components/Forms/FileBrowser';
import FormGroup from '../../../../../../components/Forms/FormGroup';

class SummaryTable extends Component {
  static propTypes = {
    registration: PropTypes.object,
    admin: PropTypes.bool,
  };
  updateDocuments = (files) => {
    const { updateRegistrationMedia } = this.props;
    updateRegistrationMedia(files);
  };

  renderPathwayRow = () => {
    const { registration } = this.props;
    const pathway = defaultTo({}, registration.pathway);
    const fees = defaultTo([], registration.registrationFees);
    const internationalFees = defaultTo([], registration.internationalFees).filter((fee) => fee.materials == true);
    if (isEmpty(pathway)) return null;

    return (
      <tr>
        <th>Pathway</th>
        <td>
          {pathway.name}
          {fees.map((fee) => (
            <div key={fee.id}>{fee.name}</div>
          ))}
          {internationalFees.map((fee) => (
            <div key={fee.id}>{fee.name}</div>
          ))}
        </td>
        <td>
          <div>&nbsp;</div>
          {fees.map((fee) => (
            <FinalPrice key={fee.id} lineItem={fee} />
          ))}
          {internationalFees.map((fee) => (
            <FinalPrice key={fee.id} lineItem={fee} />
          ))}
        </td>
      </tr>
    );
  };

  renderModulesRow = () => {
    const { registration } = this.props;
    const modules = defaultTo([], registration.trainings);
    if (isEmpty(modules)) return null;

    return (
      <tr>
        <th>{registration.trainingId ? 'Training' : 'Modules'}</th>
        <td>
          {modules.map((module) => (
            <div key={module.id}>{module.name}</div>
          ))}
        </td>
        <td>
          {modules.map((module) => (
            <FinalPrice key={module.id} lineItem={module} />
          ))}
        </td>
      </tr>
    );
  };

  renderUniversityRow = () => {
    const { registration } = this.props;
    const universityName = path(['university', 'name'], registration);
    if (isNilOrEmpty(universityName)) return null;

    return (
      <tr>
        <th>University Information</th>
        <td>
          <div>
            <strong>University:</strong> {universityName}
          </div>
          <div>
            <strong>Department / School:</strong> {registration.universityProgramDepartment}
          </div>
          <div>
            <strong>Level of Study:</strong> {registration.universityProgramLevelOfStudy}
          </div>
          <div>
            <strong>Major:</strong> {registration.universityProgramMajor}
          </div>
        </td>
        <td />
      </tr>
    );
  };

  renderSupportingDocumentationRow = (files) => {
    const { registration, admin } = this.props;
    const studentMembershipFiles = filter(propEq('type', magic.studentMembership), files);
    const MMEFiles = filter(propEq('type', magic.mme), files);
    const nonProfitFiles = filter(propEq('type', magic.nonProfitStatus), files);
    const courseworkFiles = filter(propEq('type', magic.coursework), files);
    const designationFiles = filter(propEq('type', magic.designation), files);
    const studentExamFiles = filter(propEq('type', magic.studentExam), files);

    // TODO: Make less hardcoded
    const mmeTraining = find(propEq('trainingId', 4), registration.user.userTrainings);

    if (isEmpty(files) && isNilOrEmpty(mmeTraining)) return null;

    return (
      <tr>
        <th>Supporting Documentation</th>
        <td>
          {studentMembershipFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Student Membership"
                    files={registration.media}
                    fileKey={magic.studentMembership}
                    name="moneyManagementEssentialsFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Student Membership: </strong>
                  {studentMembershipFiles.map((file) => (
                    <File key={file.id} file={file} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
          {MMEFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Money Management Essentials"
                    files={registration.media}
                    fileKey={magic.mme}
                    name="moneyManagementEssentialsFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Money Management Essentials: </strong>
                  {MMEFiles.map((file) => (
                    <File key={file.id} file={file} onDelete={() => console.log('hey')} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
          {!isNilOrEmpty(mmeTraining) && (
            <Fragment>
              <strong>Money Management Essentials: </strong>
              <a href={mmeTraining.accredibleUrl}>Accredible Certificate</a>
            </Fragment>
          )}
          {nonProfitFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Non Profit Status"
                    files={registration.media}
                    fileKey={magic.nonProfitStatus}
                    name="nonProfitStatusFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Non Profit Status: </strong>
                  {nonProfitFiles.map((file) => (
                    <File key={file.id} file={file} onDelete={() => console.log('hey')} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
          {courseworkFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Coursework / Transcripts"
                    files={registration.media}
                    fileKey={magic.coursework}
                    name="courseworkFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Coursework / Transcripts: </strong>
                  {courseworkFiles.map((file) => (
                    <File key={file.id} file={file} onDelete={() => console.log('hey')} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
          {designationFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Designation"
                    files={registration.media}
                    fileKey={magic.designation}
                    name="designationFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Designation: </strong>
                  {designationFiles.map((file) => (
                    <File key={file.id} file={file} onDelete={() => console.log('hey')} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
          {studentExamFiles.length > 0 && (
            <div>
              {admin ? (
                <form>
                  <FileBrowser
                    fileType="Student Exam"
                    files={registration.media}
                    fileKey={magic.studentExam}
                    name="studentExamFile"
                    addFile={(file) => apiAddFile(registration.id, file)}
                    update={this.updateDocuments}
                  />
                </form>
              ) : (
                <Fragment>
                  <strong>Student Exam: </strong>
                  {studentExamFiles.map((file) => (
                    <File key={file.id} file={file} onDelete={() => console.log('hey')} />
                  ))}
                </Fragment>
              )}
            </div>
          )}
        </td>
        <td />
      </tr>
    );
  };

  renderCourseMaterialsRow = () => {
    const { registration } = this.props;
    const materials = [];
    const courseMaterials = defaultTo([], registration.courseMaterials);
    const events = defaultTo([], registration.events);
    materials.push(...courseMaterials, ...events);
    if (isEmpty(materials)) return null;

    return (
      <tr>
        <th>Course Materials</th>
        <td>
          {materials.map((option) => (
            <div key={option.id}>{option.name}</div>
          ))}
        </td>
        <td>
          {materials.map((option) => (
            <FinalPrice key={option.id} lineItem={option} />
          ))}
        </td>
      </tr>
    );
  };

  renderShippingRow = () => {
    const { registration } = this.props;
    if (isNilOrEmpty(registration.shipping)) return null;

    return (
      <tr>
        <th>Shipping</th>
        <td>
          {registration.shipping.name}
          <br />
          {registration.shipping.addressLine1}
          <br />
          {registration.shipping.addressLine2}
          {registration.shipping.addressLine2 && <br />}
          {registration.shipping.city}, {registration.shipping.state} {registration.shipping.zip}{' '}
          {registration.shipping.country}
        </td>
        <td />
      </tr>
    );
  };

  renderMembershipRow = () => {
    const { registration } = this.props;
    const membership = defaultTo({}, path(['memberships', 0], registration));
    if (isEmpty(membership)) return null;

    return (
      <tr>
        <th>Membership</th>
        <td>{membership.name}</td>
        <td>
          <FinalPrice lineItem={membership} />
        </td>
      </tr>
    );
  };

  renderDonationRow = () => {
    const { registration } = this.props;
    const donation = defaultTo({}, path(['donations', 0], registration));
    if (isEmpty(donation)) return null;

    return (
      <tr>
        <th>Donation</th>
        <td>{donation.name}</td>
        <td>
          <FinalPrice lineItem={donation} readonly />
        </td>
      </tr>
    );
  };

  renderExamsRow = () => {
    const { registration } = this.props;
    const exams = defaultTo([], registration.exams);
    const internationalFees = defaultTo([], registration.internationalFees).filter((fee) => fee.exams == true);
    if (isEmpty(exams) || registration.step == magic.pathwayApprovalStep) return null;

    return (
      <tr>
        <th>Exams</th>
        <td>
          {exams.map((exam) => (
            <div key={exam.id}>{exam.name}</div>
          ))}
          {internationalFees.map((fee) => (
            <div key={fee.id}>{fee.name}</div>
          ))}
        </td>
        <td>
          {exams.map((exam) => (
            <FinalPrice key={exam.id} lineItem={exam} />
          ))}
          {internationalFees.map((fee) => (
            <FinalPrice key={fee.id} lineItem={fee} />
          ))}
        </td>
      </tr>
    );
  };

  renderDiscountRow = (discount) => {
    return (
      <tr>
        <th>Discount</th>
        <td>
          {discount.code} ({discount.percentage ? `-${discount.amount}%` : `-${toCurrency(discount.amount)}`})
        </td>
        <td />
      </tr>
    );
  };

  render() {
    const { registration } = this.props;
    const files = defaultTo([], registration.media);

    // TODO: Figure out a better way to get the discount
    const trainings = defaultTo([], registration.trainings);
    const fees = defaultTo([], registration.registrationFees);
    const internationalFees = defaultTo([], registration.internationalFees).filter((fee) => fee.materials == true);
    const courseMaterials = defaultTo([], registration.courseMaterials);
    const events = defaultTo([], registration.events);
    const membership = defaultTo({}, path(['memberships', 0], registration));
    const exams = defaultTo([], registration.exams);
    const lineItems = [...trainings, ...fees, ...internationalFees, ...courseMaterials, events, membership, exams];
    const discount = getDiscountFromLineItems(lineItems);

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Step</th>
            <th>Selection</th>
            <th>Price {discount && '(After Discount)'}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderPathwayRow()}
          {this.renderModulesRow()}
          {this.renderUniversityRow()}
          {this.renderSupportingDocumentationRow(files)}
          {this.renderCourseMaterialsRow()}
          {this.renderShippingRow()}
          {this.renderMembershipRow()}
          {this.renderDonationRow()}
          {this.renderExamsRow()}
          {!isNilOrEmpty(discount) && this.renderDiscountRow(discount)}
        </tbody>
      </table>
    );
  }
}

export default SummaryTable;
